import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  SlugField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Lead Type Schema - Типы лидов для разных воронок
 */
export const LeadTypeSchema = Type.Object({
  ...SystemFields,
  name: StringField({
    title: 'Название типа лида',
    minLength: 1,
    maxLength: 100,
    description: 'Название типа лида (например, "Заявка с сайта", "Партнёрский лид")',
  }),
  slug: SlugField({
    title: 'Slug',
    description: 'Уникальный идентификатор типа лида (например, SITE, PARTNER)',
  }),
  description: StringField({
    title: 'Описание',
    nullable: true,
    maxLength: 500,
    description: 'Описание типа лида',
  }),
  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Тип лида активен и доступен для выбора',
  }),
});

export type LeadType = Static<typeof LeadTypeSchema>;

export default defineSchema({
  moduleName,
  tableName: 'lead_types', // System will prefix with 'crm_'
  schema: LeadTypeSchema,
  additionalIndexes: ['name', { columns: ['slug'], unique: true }, 'is_active'],
});
